import { render } from "./index.vue?vue&type=template&id=4aa278ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4aa278ce"

export default script